module.exports = "<md-button\n  class=\"md-fab link-pointer\"\n  ng-class=\"{'scrolling': $ctrl.breakPointReached }\"\n  aria-label=\"Back to Top\"\n  ng-click=\"$ctrl.scrollToTop()\"\n>\n  <md-tooltip md-direction=\"top\">Back to Top</md-tooltip>\n  <md-icon>keyboard_arrow_up</md-icon>\n</md-button>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/backToTop/backToTop.html
// module id = 1114
// module chunks = 0